import { Checkbox, ListItemText, MenuItem } from "@mui/material";

export default function ToggleMenuItem(props:{onClick:any,checked:boolean,text:string}){
    return <MenuItem onClick={props.onClick}>
        <Checkbox checked={props.checked}/>
        <ListItemText>{props.text}</ListItemText>
    </MenuItem>
}